<div class="card dialog-card">
  <div class="card-header">
    <h3 class="header-title">
      {{ "administration.changeMemberRole.title" | translate }}
    </h3>

    <button type="button" class="close-button" (click)="dialogRef.close(false)" [attr.aria-label]="'common.close' | translate">
      <lucide-angular name="x" [size]="20"></lucide-angular>
    </button>
  </div>

  <form [formGroup]="roleForm" (ngSubmit)="submit()" class="card-content">
    <p class="dialog-message">
      {{ "administration.changeMemberRole.message" | translate: { email: data.member.email } }}
    </p>

    <!-- Role Field -->
    <div class="field">
      <label class="label" for="role">{{ "common.role" | translate }}</label>
      <select id="role" class="form-input" formControlName="role" (change)="errorCode = null">
        <option *ngFor="let role of roles" [value]="role">
          {{ "administration.role." + role | translate }}
        </option>
      </select>

      <div class="error-message" *ngIf="roleForm.controls.role.touched && roleForm.controls.role.errors?.['required']">
        <span>{{ "common.required" | translate }}</span>
      </div>

      <div class="error-message" *ngIf="errorCode">
        <span>{{ "administration.memberManagement.error." + errorCode | translate }}</span>
      </div>
    </div>

    <!-- Actions -->
    <div class="form-actions">
      <button class="button-secondary" type="button" (click)="dialogRef.close(false)">
        {{ "button.cancel" | translate }}
      </button>

      <button class="button-blue" type="submit" [disabled]="roleForm.disabled || isRoleUnchanged">
        {{ "button.save" | translate }}
      </button>
    </div>
  </form>
</div>
